import { AxiosResponse } from 'axios';
import { get, post } from 'services/api';

import { IContactSettingsFormData } from 'views/ContactSettingsView/types';
import { IContactFormData } from 'views/public/ContactView/types';

export const getContact = (): Promise<AxiosResponse> => get('settings/contact');

export const saveContact = (formData: IContactSettingsFormData): Promise<AxiosResponse> =>
  post('settings/contact', formData);

export const sendEmail = (formData: IContactFormData): Promise<AxiosResponse> =>
  post('contact/send-mail', formData);
